"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _IconBase = _interopRequireDefault(require("cccisd-icons/dist/IconBase.js"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _reportTemplates = _interopRequireDefault(require("../../../Reports/reportTemplates.js"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _style = _interopRequireDefault(require("./style.css"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _arrowResize = _interopRequireDefault(require("cccisd-icons/arrow-resize3"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } // Icons
var validate = exports.validate = function validate(values, props) {
  var errors = {};
  return errors;
};
var _default = exports["default"] = function _default(props) {
  var container = props.container,
    text = props.text,
    tooltip = props.tooltip,
    tables = props.tables,
    icons = props.icons,
    reports = props.reports;
  var content = {};
  if (props.content.type.value === 'report') {
    if (reports.list) {
      content = reports.list.find(function (r) {
        return r.id === props.content.handle.value;
      });
    }
  }
  if (props.content.type.value === 'table') {
    if (tables.list) {
      content = tables.list.find(function (t) {
        return t.id === props.content.handle.value;
      });
    }
  }
  var iconOptions = icons.map(function (icon) {
    return {
      value: icon.id,
      label: /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].iconBox,
        style: icon.backgroundColor ? {
          backgroundColor: icon.backgroundColor
        } : {
          backgroundColor: icon.color
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        style: icon.backgroundColor ? {
          color: icon.color,
          fontSize: '1.5em'
        } : {
          color: '#fff',
          fontSize: '1.5em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_IconBase["default"], {
        viewBox: icon.viewBox,
        key: icon.id
      }, /*#__PURE__*/_react["default"].createElement("g", null, icon.paths.map(function (p, index) {
        return /*#__PURE__*/_react["default"].createElement("path", {
          key: index,
          d: p
        });
      })))))
    };
  });
  iconOptions.push({
    value: 'url',
    label: /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].iconBox
    }, /*#__PURE__*/_react["default"].createElement("span", null, "Use Upload"))
  });
  var tileTemplateOptions = [{
    value: 'report',
    label: 'Report'
  }, {
    value: 'table',
    label: 'Table'
  }];
  var handleDeleteTile = function handleDeleteTile(tileId) {
    var indexOfTile = container.tiles.findIndex(function (tile) {
      return tile.id.value === tileId;
    });
    container.tiles.removeField(indexOfTile);
  };
  var _renderTile = function _renderTile() {
    var icon = {
      id: 'site',
      paths: ['M1024 590.444l-512-397.426-512 397.428v-162.038l512-397.426 512 397.428zM896 576v384h-256v-256h-256v256h-256v-384l384-288z'],
      backgroundColor: '#f2d56e',
      color: '#fff',
      viewBox: '0 0 1024 1024'
    };
    if (props.icon.value !== 'url') {
      icon = icons.find(function (i) {
        return i.id === props.icon.value;
      });
    }
    var tile = /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].tileContent
    }, props.icon.value === 'url' ? /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].imageIcon,
      style: {
        backgroundImage: "url(".concat(props.iconUrl.value, ")")
      }
    }) : /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].iconBox,
      style: icon.backgroundColor ? {
        backgroundColor: icon.backgroundColor
      } : {
        backgroundColor: icon.color
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: icon.backgroundColor ? {
        color: icon.color,
        fontSize: '1.5em'
      } : {
        color: '#fff',
        fontSize: '1.5em'
      }
    }, /*#__PURE__*/_react["default"].createElement(_IconBase["default"], {
      viewBox: icon.viewBox,
      key: icon.id
    }, /*#__PURE__*/_react["default"].createElement("g", null, icon.paths.map(function (p, index) {
      return /*#__PURE__*/_react["default"].createElement("path", {
        key: index,
        d: p
      });
    }))))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].textBox
    }, text.value));
    if (tooltip.value && tooltip.value.length > 0) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: tooltip.value
      }, tile);
    }
    return tile;
  };

  // console.log('templates', reportTemplates);
  // console.log(props.reports);

  var _renderReportPlayer = function _renderReportPlayer() {
    var tileReportHandle = props.content.value.handle;
    var reportSettings = props.reports.list.find(function (report) {
      return report.id === tileReportHandle;
    });
    var currentReportTemplate;
    if (reportSettings) {
      currentReportTemplate = _reportTemplates["default"].find(function (item) {
        return item.handle === reportSettings.reportTemplateHandle;
      });
    }
    if (!currentReportTemplate) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Couldn't find this Report.");
    }
    var Player = currentReportTemplate.player;
    return /*#__PURE__*/_react["default"].createElement(Player, {
      isPreview: true,
      settings: reportSettings.reportTemplateSettings,
      widgetProps: currentReportTemplate.widgetProps ? currentReportTemplate.widgetProps : {}
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].tileMenu
  }, /*#__PURE__*/_react["default"].createElement("div", _extends({}, props.dragHandleProps, {
    className: _style["default"].dragHandle
  }), /*#__PURE__*/_react["default"].createElement(_arrowResize["default"], null)), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    title: text.value,
    trigger: /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        marginRight: '3px'
      }
    }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      title: /*#__PURE__*/_react["default"].createElement(_pencil["default"], null),
      className: "btn btn-success btn-xs"
    })),
    render: function render(_ref) {
      var closeModal = _ref.closeModal;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        label: "Name",
        field: text,
        required: true
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3",
        style: {
          marginBottom: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].label
      }, "Icon"), iconOptions.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("button", {
          key: option.value,
          type: "button",
          className: 'btn btn-secondary ' + (option.value === props.icon.value ? 'active' : ''),
          onClick: function onClick() {
            props.icon.onChange(option.value);
          }
        }, option.label);
      })), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: props.iconUrl,
        label: ""
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.ImagePicker, {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-secondary"
        }, "Upload image"),
        onChange: function onChange(value) {
          return props.iconUrl.onChange(value.url);
        }
      })), props.iconUrl.value && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
        src: props.iconUrl.value,
        alt: "Tile Icon",
        width: "100px",
        height: "100px"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3",
        style: {
          marginBottom: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].label
      }, "Type"), tileTemplateOptions.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("button", {
          key: option.label,
          type: "button",
          className: 'btn btn-secondary ' + (option.value === props.content.type.value ? 'active' : ''),
          onClick: function onClick() {
            props.content.type.onChange(option.value);
          }
        }, option.label);
      })), props.content.type.value === 'report' && /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: props.content.handle,
        label: "Report"
      }, /*#__PURE__*/_react["default"].createElement("select", _extends({
        className: "form-select"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(props.content.handle), {
        style: {
          width: '100%'
        }
      }), /*#__PURE__*/_react["default"].createElement("option", {
        value: ""
      }, "-- Select report --"), props.reports.list.map(function (report) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: report.id,
          value: report.id
        }, report.id);
      }))), props.content.type.value === 'table' && /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: props.content.handle,
        label: "Table"
      }, /*#__PURE__*/_react["default"].createElement("select", _extends({
        className: "form-select"
      }, (0, _cccisdReduxFormHelpers.domOnlyProps)(props.content.handle), {
        style: {
          width: '100%'
        }
      }), /*#__PURE__*/_react["default"].createElement("option", {
        value: ""
      }, "-- Select table --"), props.tables.list ? props.tables.list.map(function (table) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: table.id,
          value: table.id
        }, table.id);
      }) : 'no tables')), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
        label: "Tooltip",
        field: tooltip
      }), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-secondary",
        onClick: closeModal
      }, "Ok"));
    }
  }), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
    title: /*#__PURE__*/_react["default"].createElement(_cross["default"], null),
    className: "btn btn-danger btn-xs",
    isConfirm: true,
    confirmationMessage: "Are you sure you want to delete this Report Tile: ".concat(text.value || "Unlabeled Report", "?"),
    onClick: function onClick() {
      return handleDeleteTile(props.id);
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    title: text.value,
    size: "large",
    trigger: _renderTile(),
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, props.content.type.value === 'table' && content ? /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], content.table) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, _renderReportPlayer())))));
};